import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Row, Col, Label} from 'reactstrap';
import LoadingImage from "../../../comum/components/LoadingImage";
import Checkbox from '../../../comum/components/Checkbox'
import FormSelectSimples from "../../../comum/components/FormSelectSimples";
import {IconeDelete} from "../../../comum/components/Icones";
import FormInputSimples from "../../../comum/components/FormInputSimples";
import {buscaSemResultado} from "../../../../utils/mensagens";
import CheckboxArea from "../../../comum/components/CheckboxArea";

@inject("store")
@observer
export class AreaSelecaoNCMsMultiplos extends Component{

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;

        this.controllerCadastrar = this.props.controller;
        this.pos = this.props.posContainer;
    };

    // Tabela
    headerTableSelecaoNCM = (sizeColumn) => {
        return  <Row className="header-row">
                    <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                        <Checkbox onClick={ () => this.controllerCadastrar.marcarTodosNCMMultiplos(this.pos) } 
                                ativo={ this.controllerCadastrar.listaComponente.items[this.pos].todosNCMsMarcados } 
                                bloqueado={this.props.bloqueado}
                        />
                    </Col>
                    <Col xs={sizeColumn} sm={sizeColumn} md={sizeColumn} lg={sizeColumn} xl={sizeColumn}>
                        <Label className="header-label">
                            NCMs
                        </Label>
                    </Col>            
                </Row>;
    };

    dataTableSelecaoNCM = (sizeColumn) => {
        return this.controllerCadastrar.listaComponente.items[this.pos].ncms.map((ncm, index) =>
            <Row key={ncm.MercId} className="row-lista formulario">
                <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                    <Checkbox onClick={ () => this.controllerCadastrar.marcarNCMMultiplos(ncm, this.pos) } 
                              ativo={ncm.marcado}
                              bloqueado={this.props.bloqueado}
                    />
                </Col>
                <Col xs={sizeColumn} sm={sizeColumn} md={sizeColumn} lg={sizeColumn} xl={sizeColumn}>
                    <Label>
                        {ncm.MercId}
                    </Label>
                </Col>                
            </Row>)
    };
    // FIM Tabela

    // Lista de cards
    listaCards = () => {
        return this.controllerCadastrar.listaComponente.items[this.pos].ncms.map((ncm, index) =>
            <Row key={ncm.CodCntr} className="card-detalhe formulario">
                <CheckboxArea xs={12} sm={12} md={12} lg={12} xl={12}
                              mensagem={ <Label className="label-disabled">{ ncm.MercId }</Label> }
                              checked={ ncm.marcado }
                              onClick={ () => this.controllerCadastrar.marcarNCMMultiplos(ncm, this.pos) } 
                              bloqueado={this.props.bloqueado}
                />                
            </Row>)
    };
    // FIM Lista de cards

    tabela = (sizeColumn) => {
        if (!this.controllerCadastrar.listaComponente.items[this.pos].salvando)
        {
            if (!this.appStore.isMobile()) {
                return <React.Fragment>
                        { this.headerTableSelecaoNCM(sizeColumn) }
                        { this.dataTableSelecaoNCM(sizeColumn) }
                    </React.Fragment>
            } else {
                return this.listaCards();
            }
        }        
    };

    render() {
        const sizeColumn = this.controllerCadastrar.listaComponente.items[this.pos].parametrosDeCampos.selectNotas ? 3 : 4;
        return <div className="area-selecao-container">               
                    <div className="tabela-home-made">
                        { this.controllerCadastrar.listaComponente.items[this.pos].loadingNCMs ? <LoadingImage />
                            : <React.Fragment>
                                { (!tthis.controllerCadastrar.listaComponente.items[this.pos].ncms ||this.controllerCadastrar.listaComponente.items[this.pos].ncms.length===0)
                                    ? <Row>
                                        <Col xs={12}>
                                            <span className="mensagem-filtrar">
                                                { buscaSemResultado }
                                            </span>
                                        </Col>
                                    </Row>
                                    : <React.Fragment>
                                        { this.tabela(sizeColumn) }
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        }
                    </div>
            </div>;
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamentoservicosTotal/cadastrar/components/AreaSelecaoNCMsMultiplos.js